import React, { useCallback } from 'react';
import SelectSearch, { fuzzySearch } from 'react-select-search';

const DropdownSearch = ({ changeHandler, curValue, options }) => {
    
    const renderValue = useCallback((valueProps) => {
        let valueToShow = valueProps.value ? valueProps.value : curValue;
        if (valueProps?.ref?.current?.value === "") {
            valueToShow = valueProps.value;
        }
        const selectedOption = options.find(option => option.value === valueToShow);
        return (
            <input
                className='select-search__input'
                title={selectedOption ? selectedOption.name : valueToShow}
                {...valueProps}
                value={selectedOption ? selectedOption.name : valueToShow}
            />
        );
    }, [curValue, options]);

    const renderOption = useCallback((optionsProps, optionData, optionSnapshot, className) => {
        const name = optionData.name || optionData.item?.name || '';
        return name ? (
            <button {...optionsProps} type="button" className={className}>
                {name}
            </button>
        ) : null;
    }, []);

    return (
        <SelectSearch
            onChange={changeHandler}
            value={curValue}
            options={options}
            search
            renderValue={renderValue}
            renderOption={renderOption}
            filterOptions={fuzzySearch}
            placeholder="Select an option"
        />
    );
};

export default DropdownSearch;